import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SalesPortalUpdateAlertStatusesDocument = gql`
  mutation SalesPortalUpdateAlertStatuses(
    $alertStatus: AnalyticsAlertStatusType!
    $alertUUIDs: [uuid!]!
    $businessOrganizationUUID: uuid!
  ) {
    updateAnalyticsAlertsStatuses(
      alert_status: $alertStatus
      alert_ids: $alertUUIDs
      business_organization_id: $businessOrganizationUUID
    ) {
      updatedCount: updated_count
    }
  }
`;
export type SalesPortalUpdateAlertStatusesMutationFn = Apollo.MutationFunction<
  Types.SalesPortalUpdateAlertStatusesMutation,
  Types.SalesPortalUpdateAlertStatusesMutationVariables
>;
export function useSalesPortalUpdateAlertStatusesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SalesPortalUpdateAlertStatusesMutation,
    Types.SalesPortalUpdateAlertStatusesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SalesPortalUpdateAlertStatusesMutation,
    Types.SalesPortalUpdateAlertStatusesMutationVariables
  >(SalesPortalUpdateAlertStatusesDocument, options);
}
export type SalesPortalUpdateAlertStatusesMutationHookResult = ReturnType<
  typeof useSalesPortalUpdateAlertStatusesMutation
>;
export type SalesPortalUpdateAlertStatusesMutationResult =
  Apollo.MutationResult<Types.SalesPortalUpdateAlertStatusesMutation>;
export type SalesPortalUpdateAlertStatusesMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SalesPortalUpdateAlertStatusesMutation,
    Types.SalesPortalUpdateAlertStatusesMutationVariables
  >;
